<template>
  <v-card flat>
    <v-container fluid>
      <div class="">
        <h4 class="earth-color">ADD ACTIVITY PRICING</h4>
      </div>
      <div >
        <v-form  @submit.prevent="postPricing()">
          <v-layout row wrap>
            <v-flex lg6 md6 sm12 xs12>
              <v-container>
                <v-dialog
                  ref="dialog"
                  persistent
                  v-model="modal1"
                  lazy
                  full-width
                  width="290px"
                  :return-value.sync="inventory.start_date"
                >
                  <v-text-field
                    slot="activator"
                    label="Start Date"
                    v-model="inventory.start_date"
                    readonly
                  ></v-text-field>
                  <v-date-picker
                    v-model="inventory.start_date"
                    scrollable
                    :min="today"
                  >
                    <v-spacer></v-spacer>
                    <v-btn :depressed="true" flat color="primary" @click="modal1 = false">Cancel</v-btn>
                    <v-btn :depressed="true" flat color="primary" @click="$refs.dialog.save(inventory.start_date)">OK</v-btn>
                  </v-date-picker>
                </v-dialog>
              </v-container>
            </v-flex>
            <v-flex lg6 md6 sm12 xs12>
              <v-container>
                <v-dialog
                  ref="dialog1"
                  persistent
                  v-model="modal2"
                  lazy
                  full-width
                  width="290px"
                  :return-value.sync="inventory.end_date"
                >
                  <v-text-field
                    slot="activator"
                    label="End Date"
                    v-model="inventory.end_date"
                    readonly
                  ></v-text-field>
                  <v-date-picker
                    v-model="inventory.end_date"
                    scrollable
                    :min="inventory.start_date"
                  >
                    <v-spacer></v-spacer>
                    <v-btn :depressed="true" flat color="primary" @click="modal2 = false">Cancel</v-btn>
                    <v-btn :depressed="true" flat color="primary" @click="$refs.dialog1.save(inventory.end_date)">OK</v-btn>
                  </v-date-picker>
                </v-dialog>
              </v-container>
            </v-flex>
            <v-flex lg3 md3 sm12 xs12>
              <v-container fluid>
                <v-autocomplete
                  label="Select Currency"
                  v-model="inventory.currency_type"
                  :items="allCurrencyTypes"
                  :rules="[v => !!v || 'Currency is required']"
                  required
                  item-text="currency_name"
                  item-value="currency_public_id"
                  :loading="$loadingTrue"
                ></v-autocomplete>
              </v-container>
            </v-flex>
            <v-flex lg3 md3 sm12 xs12>
              <v-container>
                <v-text-field
                  label="Adult Price"
                  v-model="inventory.adult_price"
                  :rules="requiredRules"
                  required
                  type="number"
                  min="0"
                ></v-text-field>
              </v-container>
            </v-flex>
            <v-flex lg3 md3 sm12 xs12>
              <v-container>
                <v-text-field
                  label="Child Price"
                  v-model="inventory.child_price"
                  :rules="requiredRules"
                  required
                  type="number"
                  min="0"
                ></v-text-field>
              </v-container>
            </v-flex>
            <v-flex lg3 md3 sm12 xs12>
              <v-container fluid>
                <v-btn :depressed="true" block color="primary" type="submit">Add Price Schedule</v-btn>
              </v-container>
            </v-flex>
          </v-layout>
        </v-form>
      </div>
      <div class="row">
        <div class="col-md-12">
          <table cellpadding="1" cellspacing="1" class="table table-bordered">
            <thead>
            <tr>
              <td>Start Date</td>
              <td>End Date</td>
              <td>Currency</td>
              <td>Adult Price</td>
              <td>Child Price</td>
              <td>Action</td>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(schedule, key) in inventoryPriceSchedule" :key="key">
              <td>{{formated_date(schedule.start_date)}}</td>
              <td>{{formated_date(schedule.end_date)}}</td>
              <td>{{schedule.currency_type}}</td>
              <td>{{schedule.adult_price}}</td>
              <td>{{schedule.child_price}}</td>
              <td>
                <v-btn :depressed="true" small color="error" @click="deleteSchedule(schedule.public_id)">Disable</v-btn>
                <!--<button class="btn btn-info btn-sm" @click="disableDiscount(d)">Edit</button>-->
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </v-container>
  </v-card>
</template>

<script>
export default {
  name: 'inventory-pricing',
  data () {
    return {
      today: this.$moment().format('YYYY-MM-DD'),
      requiredRules: [
        v => !!v || 'This field is required'
      ],
      menu1: false,
      modal1: false,
      menu2: false,
      modal2: false,
      inventory: {
        public_id: this.$route.params.inventory_id,
        start_date: '',
        end_date: '',
        currency_type: '',
        adult_price: '',
        child_price: '',
        inventory_id: this.$route.params.inventory_id,
        session_id: localStorage.getItem('lkjhgfdsa')
      }
    }
  },
  created () {
    this.$store.dispatch('get_activity_pricings', this.$route.params.inventory_id)
    this.$store.dispatch('get_all_currency_types')
  },
  methods: {
    deleteSchedule: function (publicId) {
      var data = {
        public_id: publicId,
        deleted_by: localStorage.getItem('lkjhgfdsa'),
        inventory: this.$route.params.inventory_id
      }
      this.$store.dispatch('delete_activity_pricing', data)
    },
    putStartDate: function () {
      var date = this.inventory.start_date
      date = this.$moment(date).format('YYYY-MM-DD')
      this.inventory.start_date = date
    },
    putEndtDate: function () {
      var date = this.inventory.end_date
      date = this.$moment(date).format('YYYY-MM-DD')
      this.inventory.end_date = date
    },
    clearInput () {
      this.inventory.start_date = ''
      this.inventory.end_date = ''
      this.inventory.currency_type = ''
      this.inventory.adult_price = ''
      this.inventory.child_price = ''
    },
    postPricing: function () {
      var instance = this
      this.$store.dispatch('post_activity_pricing', this.inventory).then(function () {
        // instance.clearInput()
      })

    }
  }
}
</script>

<style scoped>

</style>
